import Link from 'next/link';
import { ReactElement, memo } from 'react';
import emptyImg from '@/shared/images/Images/EmptyImg.png';

import * as S from './DestinationCard.styles';

export type DestinationCardProps = {
    imageSrc: string;
    imageAlt?: string;
    title: string;
    experience: string;
    cardLink: string;
};

export const DestinationCardContainer = ({
    imageSrc,
    title,
    experience,
    imageAlt,
    cardLink,
}: DestinationCardProps): ReactElement => {
    return (
        <Link href={cardLink.toLowerCase()} passHref prefetch={false}>
            <S.Wrapper>
                <S.Gradient />
                <S.Image
                    src={imageSrc}
                    alt={imageAlt || title}
                    loading="lazy"
                    height="220"
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${emptyImg.src}`;
                    }}
                />
                <S.Title>{title}</S.Title>
                <S.Experience>{experience}</S.Experience>
            </S.Wrapper>
        </Link>
    );
};

export const DestinationCard = memo(DestinationCardContainer);
export default DestinationCard;
